import axios from "axios";
import siteUrls from "../api-config/ApiConfig";
import toast from "react-hot-toast";

export const companyRegister = async (payload) => {
    const response = await axios.post(siteUrls.companyRegister.post, payload);
    return response;
};

export const imageUpload = async (payload) => {
    try {
        const imageUpload = await axios.post(siteUrls.imageUpload.singleUpload.post, payload);
        return imageUpload;
    } catch (error) {
        console.error('Error in Upload', error);
        toast.error(error.response.data.msg)
    }
};

export const getProfile = async () => {
    const response = await axios.get(`${siteUrls.auth.profile}`);
    return response
};